const schema = () => ({
  type: 'object',
  required: [],
  properties: {},
});

export default schema;
